import { Input, ItandiChip, InputRadio } from '@itandi/itandi-bb-ui';
import { useFormContext } from 'react-hook-form';
import Styles from './Block.module.scss';
import type { DealParam, RelatedDealParam } from '~/models/DealForm';

type Props = {
  isTenantNameDisabled?: boolean;
  isTenantNameKanaDisabled?: boolean;
  isTenantTelDisabled?: boolean;
  isTenantEmailDisabled?: boolean;
};

export const TenantBlockBase: React.FC<Props> = ({
  isTenantNameDisabled = false,
  isTenantNameKanaDisabled = false,
  isTenantTelDisabled = false,
  isTenantEmailDisabled = false
}) => {
  const { register, formState, watch } = useFormContext<
    DealParam | RelatedDealParam
  >();
  const { errors } = formState;
  const dealType: 'restoration' | 'repair' | 'other' | null = watch('dealType');
  const inspectionBy = watch('inspectionBy');

  return (
    <>
      {dealType === 'restoration' && (
        <div className={Styles.FormRow}>
          <div className={Styles.FormLabel}>
            <span className={Styles.FormLabelText}>立会者</span>
            <span className={Styles.RequiredLabel}>
              <ItandiChip label="必須" />
            </span>
          </div>
          <div className={Styles.FormContent}>
            <div className={Styles.InputRadioGroup}>
              <InputRadio
                label="施工会社"
                value="vendor"
                {...register('inspectionBy')}
              />
              <InputRadio
                label="管理会社"
                value="company"
                {...register('inspectionBy')}
              />
              <InputRadio
                label="なし"
                value="none"
                {...register('inspectionBy')}
              />
            </div>
            <div className={Styles.ErrorMessage}>
              {errors.inspectionBy?.message}
            </div>
          </div>
        </div>
      )}
      <div className={Styles.FormRow}>
        <div className={Styles.FormLabel}>
          <span className={Styles.FormLabelText}>氏名</span>
          <span className={Styles.RequiredLabel}>
            <ItandiChip label={inspectionBy === 'vendor' ? '必須' : '任意'} />
          </span>
        </div>
        <div className={Styles.FormContent}>
          <div className={Styles.NameKanaGroup}>
            <div className={Styles.NameInputWrapper}>
              <Input
                disabled={isTenantNameDisabled}
                isInvalid={errors.tenantName != null}
                placeholder="例）内装 太郎"
                {...register('tenantName')}
              />
            </div>
            {errors.tenantName != null && (
              <div className={Styles.ErrorMessage}>
                {errors.tenantName.message}
              </div>
            )}
            <div className={Styles.NameInputLabel}>カナ</div>
            <div>
              <Input
                disabled={isTenantNameKanaDisabled}
                isInvalid={errors.tenantNameKana != null}
                placeholder="例）ナイソウ タロウ"
                {...register('tenantNameKana')}
              />
            </div>
            {errors.tenantNameKana != null && (
              <div className={Styles.ErrorMessage}>
                {errors.tenantNameKana.message}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={Styles.FormRow}>
        <div className={Styles.FormLabel}>
          <span className={Styles.FormLabelText}>電話番号</span>
          <span className={Styles.RequiredLabel}>
            <ItandiChip label={inspectionBy === 'vendor' ? '必須' : '任意'} />
          </span>
        </div>
        <div className={Styles.FormContent}>
          <div className={Styles.InputWrapper}>
            <Input
              disabled={isTenantTelDisabled}
              isInvalid={errors.tenantTel != null}
              placeholder="例）090-0000-0000"
              {...register('tenantTel')}
            />
          </div>
          {errors.tenantTel != null && (
            <div className={Styles.ErrorMessage}>
              {errors.tenantTel.message}
            </div>
          )}
        </div>
      </div>
      <div className={Styles.FormRow}>
        <div className={Styles.FormLabel}>
          <span className={Styles.FormLabelText}>メールアドレス</span>
          <span className={Styles.RequiredLabel}>
            <ItandiChip label="任意" />
          </span>
        </div>
        <div className={Styles.FormContent}>
          <div className={Styles.InputWrapper}>
            <Input
              disabled={isTenantEmailDisabled}
              isInvalid={errors.tenantEmail != null}
              placeholder="例）sample@example.com"
              {...register('tenantEmail')}
            />
          </div>
          {errors.tenantEmail != null && (
            <div className={Styles.ErrorMessage}>
              {errors.tenantEmail.message}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
